import { Tooltip, Typography, TypographyProps } from 'antd';
import { LinkProps } from 'antd/es/typography/Link';
import { Fragment } from 'react';

const getLinkedTextArray = (text: string, urlLinkClassName?: string) => {
  const linkedElements: JSX.Element[] = [];

  text.replace(
    /((?:https?:\/\/|ftps?:\/\/|\bwww\.)(?:(?![.,?!;:()]*(?:\s|$))[^\s]){2,})|(\n+|(?:(?!(?:https?:\/\/|ftp:\/\/|\bwww\.)(?:(?![.,?!;:()]*(?:\s|$))[^\s]){2,}).)+)/gim,
    (original, link, text) => {
      linkedElements.push(
        link ? (
          <Typography.Link
            style={{ color: 'inherit'}}
            className={urlLinkClassName}
            target='_blank'
            href={(link[0] === 'w' ? '//' : '') + link}
            key={linkedElements.length}
          >
            {link}
          </Typography.Link>
        ) : (
          text
        )
      );

      return original;
    }
  );

  return linkedElements;
};

export const checkUserMentioned = (text: string, userEmail: string): boolean => {
  if (!text || !userEmail) return false;
  const userTagRegex = /\[user:([^\]]+)\]([^\[]*)\[\/user\]/g;
  // @ts-ignore 
  const matches = Array.from([...text.matchAll(userTagRegex)]);
  return matches.some((match) => match[1] === userEmail);
};

const parseUserTags = (content: string | JSX.Element, userTagClassName?: string): JSX.Element | string => {
  if (typeof content !== 'string') return content;
  
  const userTagRegex = /\[user:([^\]]+)\]([^\[]*)\[\/user\]/g;
  // @ts-ignore 
  const userMatches = Array.from([...content.matchAll(userTagRegex)]);
  
  if (!userMatches.length) return content;
  
  const splited = content.split(userTagRegex);
  const result: (string | JSX.Element)[] = [];
  
  let matchIndex = 0;
  for (let i = 0; i < splited.length; i++) {
    if (i % 3 === 0) {
      //  текст между тегами
      result.push(splited[i]);
    } else if (i % 3 === 1) {
      // email (пропускаем)
      continue;
    } else if (i % 3 === 2) {
      // Имя пользователя
      const userName = splited[i];
      result.push(
        <span key={`user-tag-${matchIndex}`} className={userTagClassName}>
          @{userName}
        </span>
      );
      matchIndex++;
    }
  }
  
  return <>{result}</>;
};

export const parsedChatMessages = (
  text: string,
  props: LinkProps,
  title?: string,
  urlLinkClassName?: string,
  userTagClassName?: string
) => {
  const linkedMessages = getLinkedTextArray(text, urlLinkClassName);

  const parsedTagsMessages = linkedMessages.map((element, index) => {
    if (typeof element !== 'string') return element;
    
    // @ts-ignore
    const tags = Array.from([...(element as string).matchAll(/\[link\](.+?)\[\/link\]/gm)]?.map((match) => match[1])); // сделал оббертку [...value], так как в safari выбрасывало ошибку TypeError: _matchAll.map is not a function. (In '_matchAll.map(match => match[1])', '_matchAll.map' is undefined)
    // const tags = Array.from((element as string).matchAll(/\[link\](.+)\[\/link\]/gm)?.map((match) => match[1])); // http://10.1.3.25/issues/12505    

    let parsedContent: JSX.Element | string = element;
    
    if (tags.length) {
      const splited = (element as string).split(/\[link\].+?\[\/link\]/);
      parsedContent = (
        <Fragment key={`parsedTags-${index}`}>
          {splited.map((split, idx) => (
            <Fragment key={`tag-${tags[idx]}-${idx}`}>
              {parseUserTags(split, userTagClassName)}
              {idx < splited.length - 1 ? (
                <Tooltip title={title} trigger='hover'>
                  <Typography.Link {...props}>{(tags as string[])[idx]}</Typography.Link>
                </Tooltip>
              ) : null}
            </Fragment>
          ))}
        </Fragment>
      );
    } else {
      parsedContent = parseUserTags(element, userTagClassName);
    }

    return parsedContent;
  });

  return parsedTagsMessages;
};

const replacePartWithJSX = (text: string, jsxPart: JSX.Element, targetWord: string) => {
  const parts = text.split(targetWord);
  return (
    <>
      {parts[0]}
      {jsxPart}
      {parts[1]}
    </>
  );
};

export default getLinkedTextArray;
